"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationResult = void 0;
var ValidationResult = /** @class */ (function () {
    function ValidationResult() {
        this.fields = {};
    }
    Object.defineProperty(ValidationResult.prototype, "isValid", {
        /**
         * Indicates if all fields are valid
         * @return <code>true</code> if all fields are valid
         */
        get: function () {
            var _this = this;
            return Object.keys(this.fields).every(function (key) { return _this.fields[key].isValid; });
        },
        enumerable: false,
        configurable: true
    });
    ValidationResult.prototype.toJSON = function () {
        var _this = this;
        var json = {};
        Object.keys(this.fields).forEach(function (key) {
            json[key] = _this.fields[key].toJSON();
        });
        return json;
    };
    return ValidationResult;
}());
exports.ValidationResult = ValidationResult;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmFsaWRhdGlvblJlc3VsdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlZhbGlkYXRpb25SZXN1bHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0E7SUFBQTtRQUNTLFdBQU0sR0FBc0MsRUFBRSxDQUFDO0lBaUJ4RCxDQUFDO0lBWEMsc0JBQUkscUNBQU87UUFKWDs7O1dBR0c7YUFDSDtZQUFBLGlCQUVDO1lBREMsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxLQUFLLENBQUMsVUFBQyxHQUFHLElBQUssT0FBQSxLQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLE9BQU8sRUFBeEIsQ0FBd0IsQ0FBQyxDQUFDO1FBQzNFLENBQUM7OztPQUFBO0lBRUQsaUNBQU0sR0FBTjtRQUFBLGlCQU1DO1FBTEMsSUFBTSxJQUFJLEdBQVksRUFBRSxDQUFDO1FBQ3pCLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFDLEdBQUc7WUFDbkMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEtBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDeEMsQ0FBQyxDQUFDLENBQUM7UUFDSCxPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7SUFDSCx1QkFBQztBQUFELENBQUMsQUFsQkQsSUFrQkM7QUFsQlksNENBQWdCIn0=